<script>
    import GallerySlider from "./GallerySlider.svelte";
    import GalleryList from "./GalleryList.svelte";
    import {mediaUrlStore} from "../core/app-store.js";

    export let section;
    export let tenantKey = '';

    let textCutExpanded = false;

    const showTextDataContainer = section && (section?.textBlock?.gallery?.type === 'slider' || ((section.textBlock?.text || '').length > 0) || (section.textBlock.buttons && section.textBlock.buttons.length > 0));

    function toggleCutHandler() {
        textCutExpanded = !textCutExpanded;
    }
</script>

<style>
    .text-block {
        position: relative;
        z-index: 1;
        color: var(--main-font-color);
        width: 100%;
        overflow: hidden;
    }
    .text-block--left {
        text-align: left;
    }
    .text-block--right {
        text-align: right;
    }
    .text-block--center {
        text-align: center;
    }
    .text-block.text-block--gallery-list {
        flex-direction: column !important;
        gap: 12px;
    }

    .text-content {
        position: relative;
        z-index: 10;
        padding: 1.5rem 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    .text-block.text-block--center .text-content {
        padding-top: 48px;
        padding-bottom: 48px;
    }
    .text-data-container {
        display: flex;
        flex: 1 1;
        flex-direction: column;
        gap: 1rem;
    }
    .gallery-block {}
    .info-block {
        display: flex;
        flex: 1 1;
        flex-direction: column;
        gap: 1rem;
    }

    .title {
        font-family: Roboto Condensed, sans-serif;
        font-size: 36px;
        font-weight: 800;
        color: var(--accent-color);
        line-height: 120%;
        white-space: break-spaces;
        padding: 0;
        margin: 0;
    }
    .text {
        flex: 1 1;
        font-family: Roboto, sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
        color: var(--main-font-color);
        text-shadow: 0 0 4px rgba(0, 0, 0, 0.16);
        margin: 0;
        white-space: break-spaces;
    }
    .slider {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;
    }
    .slider .gr {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: .3;
        background: radial-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 1));
        _background: radial-gradient(rgba(0, 0, 0, 0.72), black);
    }
    .slider img {
        opacity: .6;
        filter: contrast(0.9) brightness(0.9) blur(0.1px);
    }
    .buttons {
        gap: .75rem;
        columns: 300px;
        display: flex;
        flex-direction: column;
        align-items: unset;
        text-align: center;
    }
    .buttons.buttons--left {
        align-items: start;
    }
    .buttons.buttons--center {
        align-items: center;
    }
    .buttons.buttons--right {
        align-items: end;
    }
    .text-block-btn {
        border: 1px solid var(--main-font-color);
        background: var(--main-font-color);
        color: var(--bg-color);
        border-radius: 2rem;
        width: fit-content;
        text-decoration: none;
        text-align: center;
        text-transform: uppercase;
        font-family: Roboto Condensed, sans-serif;
        font-size: 16px;
        font-weight: 600;
        padding: .4rem .8rem;
        cursor: pointer;
    }
    .image {
        opacity: .35;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media (min-width: 768px) {
        .text-block {
            flex-direction: row;
            gap: 36px;
        }
        .text-block.text-block--left {
            text-align: left;
            flex-direction: row;
            align-items: center;
        }
        .text-block.text-block--right {
            text-align: right;
            flex-direction: row-reverse;
            align-items: center;
        }
        .text-block.text-block--center {
            text-align: center;
            flex-direction: row;
        }

        .text-block.text-block--center .text-content {
            padding: 48px 36px;
        }

        .text-content {
            padding-left: 0;
            padding-right: 0;
        }
        .text {
            flex: unset;
        }

        .gallery-block,
        .info-block {
            flex: 1 1;
        }
        .gallery-block {
            height: fit-content;
        }

        .text-block,
        .slider,
        .image {
            border-radius: 0;
        }
    }


.text-cut {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.text-cut--4 {-webkit-line-clamp: 4;}
.text-cut--8 {-webkit-line-clamp: 8;}
.text-cut--12 {-webkit-line-clamp: 12;}
.read-more-btn {
    border: none;
    font-size: var(--fs-120);
    font-family: inherit;
    background: transparent;
    cursor: pointer;
    line-height: 1;
    color: inherit;
    margin-bottom: -1rem;
}
.video-container {
    position: absolute;
    overflow: hidden;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
}
.video-container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>

<section class="text-block flex"
         class:text-block--left={!section.textBlock?.alignment || section.textBlock?.alignment === 'left'}
         class:text-block--right={section.textBlock?.alignment === 'right'}
         class:text-block--center={section.textBlock?.alignment === 'center'}
         class:text-block--gallery-list={section?.textBlock?.gallery?.type === 'list'}
         id={'s' + section.id}
         style:color="{section.textBlock?.textColor ? section.textBlock.textColor : 'var(--main-font-color)'}"
         style:background="{section.textBlock?.background?.color ? section.textBlock.background.color : 'var(--bg-color)'}"
         style:min-height="{section.textBlock?.height ? section.textBlock.height + 'vh' : 'unset'}"
         >

    <!-- GALLERY SLIDER (DESKTOP) -->
    {#if (section?.textBlock?.gallery?.type === 'slider')}
        <div class="gallery-block hide-on-mobile">
            <GallerySlider gallery={section.textBlock.gallery} tenantKey={tenantKey}></GallerySlider>
        </div>
    {/if}

    <div class="text-content flex flex-fill">

        {#if ((section.title || '').length > 0)}
            <h3 class="title">{ section.title }</h3>
        {/if}

        {#if (showTextDataContainer)}
            <div class="text-data-container">

                <!-- GALLERY SLIDER (MOBILE) -->
                {#if (section?.textBlock?.gallery?.type === 'slider')}
                    <div class="gallery-block hide-on-desktop">
                        <GallerySlider gallery={section.textBlock.gallery} tenantKey={tenantKey}></GallerySlider>
                    </div>
                {/if}

                <!-- INFO -->
                <div class="info-block">
                    {#if ((section.textBlock?.text || '').length > 0)}
                        <p class="text { section.textBlock.cutText && !textCutExpanded ? 'text-cut' : ''} { section.textBlock.cutText ? 'text-cut--'+section.textBlock.cutText : ''}">
                            { section.textBlock.text || '' }
                        </p>

                        {#if (section.textBlock.cutText)}
                            <button class="read-more-btn" on:click={() => toggleCutHandler()}>
                                {#if (!textCutExpanded)}
                                    <svg width="1em" height="1em" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 0.5L6 5.5L11 0.5" stroke="currentColor"/>
                                    </svg>
                                {:else}
                                    <svg width="1em" height="1em" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11 6L6 1L1 6" stroke="currentColor"/>
                                    </svg>
                                {/if}
                            </button>
                        {/if}
                    {/if}

                    {#if (section.textBlock.buttons && section.textBlock.buttons.length > 0)}
                    <div class="buttons"
                         class:buttons--left={section.textBlock.alignment === 'left'}
                         class:buttons--center={section.textBlock.alignment === 'center'}
                         class:buttons--right={section.textBlock.alignment === 'right'}
                    >
                        {#each section.textBlock.buttons as button }
                            {#if (button.text && button.link)}
                                <a class="text-block-btn"
                                   style:color="{ button.color }"
                                   style:border-color="{ button.borderColor || button.color }"
                                   style:background-color="{ button.borderColor || button.color ? 'transparent' : '' }"
                                   href="{button.link}"
                                   target={ button.target || '_blank' }
                                   rel="noopener nofollow">
                                    { button.text }
                                </a>
                            {/if}
                        {/each}
                    </div>
                {/if}
                </div>
            </div>
        {/if}

    </div>

    <!-- GALLERY LIST (DESKTOP + MOBILE) -->
    {#if (section?.textBlock?.gallery?.type === 'list')}
        <div class="gallery-block">
            <GalleryList items={section.textBlock.gallery.items} tenantKey={tenantKey}></GalleryList>
        </div>
    {/if}

    {#if section.textBlock.background?.videoUrls}
        <div class="video-container">
            <video src="{section.textBlock.background?.videoUrls[0]}" autoplay muted loop loading="lazy">
            </video>
        </div>
    {/if}

    {#if section.textBlock.background?.images}
        <div class="slider">
            <div class="gr" style="opacity: {section.textBlock.background.opacity ? section.textBlock.background.opacity : .35}"></div>
            {#each section.textBlock.background.images as image}
                {#if (image && image.length > 0)}
                    <img class="image" width="100%" src="{$mediaUrlStore}{tenantKey}{image}"
                         alt="{section.title}"
                         loading="lazy">
                {/if}
            {/each}
        </div>
    {/if}
</section>
